<template>
  <div class="soraban-delete-action">
    <v-menu content-class="soraban-delete-action-dropdown">
      <div slot="activator"><slot name="activator"></slot></div>
      <v-list>
        <button
          class="soraban-delete-action-dropdown__button"
          @click="deleteAction()"
        >
          Delete Item
        </button>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'SorabanDeleteAction',
  methods: {
    deleteAction() {
      this.$emit('delete-confirmed');
    },
  },
};
</script>

<style lang="postcss">
.soraban-delete-action-dropdown {
  /* Not scoped because menu dropdown is attached to app root */
  transform: translate(-32%, 100%);
  overflow-x: visible;
  background-color: transparent;
  text-align: center;
}

/* Center triangle tooltip-thing */

/* .soraban-delete-action-dropdown:before {
  content: '';
  display: inline-block;
  border: 8px solid transparent;
  border-bottom-color: var(--color-alert);
  position: relative;
  bottom: -5px;
} */

/*
  Need v-list and theme--light to override vuetify successfully when minified
*/
.soraban-delete-action-dropdown .v-list.theme--light {
  background-color: var(--color-alert);
}

.soraban-delete-action-dropdown__button {
  color: var(--color-white);
  text-decoration: underline;
  padding: 0 1rem;

  &:hover {
    text-decoration: none;
  }
}
</style>
